import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { flatten, head } from "lodash"
import type { StateObject } from "../../redux/types"
import { getLocationsAuthData, getMakeItButterTerminalIds } from "../../auth/selectors"
import { Terminal, TerminalType } from "../../../graphql/types"
import { GLOBAL_FILTER_IDENTIFIER } from "../../filters/reducer"
import { getFilters } from "../../filters/selectors"
import { getTerminals } from "../../screens/locations/selectors"
import { SelectItemType } from "../../uiKit/Select/Select"

export const getDataForTerminalSinglePicker = (
    state: StateObject,
    terminalTypes?: TerminalType[]
): SelectItemType[] => {
    const locations = getLocationsAuthData(state)
    return flatten(
        locations.map(location =>
            location.terminals
                .filter(terminal => (terminalTypes ? terminalTypes.includes(terminal.type) : true))
                .map(terminal => ({
                    id: terminal.id,
                    label: terminal.name,
                    groupId: location.id,
                    groupLabel: location.name,
                }))
        )
    )
}

export const getMibServicePickerSelectedId = (state: StateObject): Maybe<string> => {
    const filterValue = getFilters(state, GLOBAL_FILTER_IDENTIFIER).selectedMibTerminalId

    if (!filterValue) {
        return head(getMakeItButterTerminalIds(state))
    }

    return filterValue
}

export const getMibSelectedServiceData = (state: StateObject): Maybe<Terminal> => {
    const serviceId = getMibServicePickerSelectedId(state)

    const service = serviceId ? getTerminals(state).find(t => t.id === serviceId) : null
    if (!service || !service.locationId) {
        return null
    }

    return service
}

export const getSelectedTerminalsLocationId = (state: StateObject): Maybe<string> => {
    return getMibSelectedServiceData(state)?.locationId ?? null
}
